import { render, staticRenderFns } from "./InvoiceFlow.vue?vue&type=template&id=b6ac16d4&"
import script from "./InvoiceFlow.vue?vue&type=script&lang=js&"
export * from "./InvoiceFlow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/viewclients.css?vue&type=style&index=0&lang=css&"
import style1 from "./InvoiceFlow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports